import React, { useState, useEffect } from 'react';
//import StylishHeader from '../components/stylishHeader';
import LoadingScreenInline from '../components//loadingInline';
import { smallDetailListProviders } from '../endpoints-Calls/providers/index';
import { textInResolution, textInResolutionMobile } from '../multiFunctions';
import { generalStyleDivs } from '../styles';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouseChimneyUser, faLocationPin, faUser, faTextHeight } from '@fortawesome/free-solid-svg-icons';

function OurProvidersList(props) {
  /* eslint-disable react/prop-types */
  const [itemsProviders, setItemsProviders] = useState([]);
  const [isLoading] = useState(true);

  useEffect(() => {
    // A. Define the async function inside the effect
    const fetchData = async () => {
      try {
        const result = await smallDetailListProviders();

        setItemsProviders(result);
        //setIsLoading(false);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  return (
    <>
    {isLoading &&
      <>
      <LoadingScreenInline isFullScreen={false} />
      </>
    }

    {!isLoading && 
    <>
      { itemsProviders && itemsProviders.length > 0 ? (
        itemsProviders.map((item) => (
            <OurProviders key={item._id} provider={item} visibleCode={item.visibleCode} isLargeScreen={props.isLargeScreen} isSmallScreen={props.isSmallScreen} fontSize={props.fontSize} />
        ))
        ) : (<div></div>)
      }
      </>
    }
    
    </>
  );
}
export default OurProvidersList;

function OurProviders(prop) {
  /* eslint-disable react/prop-types */
  const isLargeScreen = prop.isLargeScreen;
  const isSmallScreen = prop.isSmallScreen;

  let screenSize = {
    width: window.screen.width,
    height: window.screen.height
  }

  let sizeFont = {
    fontSize: prop.fontSize,
    textAlign: "justify",
  }

  let paddingDesktopTextStyle = {
    padding: textInResolution("15px", "20px", "30px", "35px", screenSize),
  }

  let sizeFontSmallerText = {
    fontSize: textInResolution("medium", "large", "large", "large", screenSize),
    paddingBottom: "10px"
  }

  let styleImg = {
      margin: "10px",
      maxWidth: textInResolution("100px", "150px", "200px", "200px", screenSize),
      width: textInResolution("100px", "150px", "200px", "200px", screenSize),
      maxHeight: textInResolution("100px", "150px", "200px", "200px", screenSize),
      height: textInResolution("100px", "150px", "200px", "200px", screenSize)
  }
  let styleImgMovile = {
      maxWidth: textInResolutionMobile("150px", "200px", "200px", screenSize),
      width: textInResolutionMobile("150px", "200px", "200px",  screenSize),
  }
  let iconStyleMovile = {
    fontSize: textInResolutionMobile("20px", "25px", "25px", screenSize),
  }
  let anchorStyle = {
    textDecoration: "none",
    color: "inherit"
  }

  let currentProvider = prop.provider;
  return (
    <>
      {isLargeScreen &&
        <a href={`/ourProviders?visibleCode=${prop.visibleCode}`} style={{ ...anchorStyle }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{...generalStyleDivs, width: "95%", margin: "10px" }}>
              <div style={{ display: "flex", flexFlow: "row" }}>
                <div style={{ width: "25%" }}>
                  <div style={{ display: "flex", flexFlow: "column", alignItems: "center" }}>
                    <img src={currentProvider.logoURL} style={{ ...styleImg, paddingBottom: "10px"  }} alt='' />
                  </div>
                </div>
                <div style={{ width: "75%", display: "flex", alignItems: "center"}}>
                  <span style={{ ...sizeFont, ...paddingDesktopTextStyle }}>{currentProvider.smallDescription}</span>
                </div>
              </div>
              <div style={{ ...sizeFontSmallerText, display: "flex", justifyContent: "center", padding: "10px" }} >
                <span><FontAwesomeIcon icon={faUser} />  Provider: {currentProvider.name} | <FontAwesomeIcon icon={faHouseChimneyUser} /> Farm: {currentProvider.farm} | <FontAwesomeIcon icon={faLocationPin} /> Location: {currentProvider.location} | <FontAwesomeIcon icon={faTextHeight} /> height: {currentProvider.height} </span><br/>
              </div>
            </div>
          </div>
        </a>
      }
      {isSmallScreen && 
        <a href={`/ourProviders?visibleCode=${prop.visibleCode}`} style={{ ...anchorStyle }}>
          <div style={{display: "flex", justifyContent: "center"}}>
            <div style={{...generalStyleDivs, width: "95%", margin: "10px", display: "flex", flexFlow: "column" }}>
                <div style={{ display: "flex", flexFlow: "column", alignItems: "center" }}>
                  <div style={{ marginTop: "10px" }}>
                    <img src={currentProvider.logoURL} style={{ ...styleImgMovile }} alt='' />
                  </div>
                  <div style={{ ...sizeFont, width: "100%", paddingLeft: "20px" }} >
                    <span><FontAwesomeIcon icon={faUser} style={{ ...iconStyleMovile }}/> Provider: {currentProvider.Producer}</span><br/>
                    <span><FontAwesomeIcon icon={faHouseChimneyUser} style={{ ...iconStyleMovile }}/> Farm: {currentProvider.farm}</span><br/>
                    <span><FontAwesomeIcon icon={faLocationPin} style={{ ...iconStyleMovile }}/> Location: {currentProvider.location}</span><br/>
                    <span><FontAwesomeIcon icon={faTextHeight} style={{ ...iconStyleMovile }}/> height: {currentProvider.height}</span><br/>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", margin: "10px" }}>
                  <p style={{ ...sizeFont }}  >{currentProvider.smallDescription}</p>
                </div>
              </div>
          </div>
        </a>
      }
    </>
  )
  
}